import { DownloadState } from '@repo/core'
import { RootState } from '../../../store/types'

export const bankingProductMovementsDownloadSelectorConfig = {
  bankingProductMovementsDownloadSelector: {
    getRootPath: (state: RootState): DownloadState =>
      state.accounts.master.list.bankingProductMovementsDownload,
  },
}
